"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mask_1 = __importDefault(require("../../../../../utils/mask"));
const generateMask_1 = __importDefault(require("./generateMask"));
const clamp = (value, min, max) => {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
const getEmptyState = ({ sign, viewValue, finished, event, }) => {
    const resultViewValue = `${sign}${viewValue}`;
    return resultViewValue === '' || finished
        ? {
            viewValue: finished ? '' : resultViewValue,
            correct: true,
            value: '',
            event,
        }
        : { viewValue: resultViewValue, correct: false, value: null, event };
};
const getInputNumberFormatState = ({ input, min = -Infinity, max = Infinity, precision, finished = false, thousandsSeparator = '', decimalSeparator = '.', cast = Number, event, }) => {
    let viewValue = input;
    const sign = viewValue.startsWith('-') && min < 0 ? '-' : '';
    viewValue = viewValue.replace(/^-/, '');
    if (viewValue.length === 0) {
        return getEmptyState({ viewValue, sign, finished, event });
    }
    const dotIndex = viewValue.indexOf(decimalSeparator);
    const hasDot = dotIndex !== -1;
    viewValue = viewValue
        .split('')
        .filter((letter, index) => {
        const isDot = letter === decimalSeparator;
        return isDot ? dotIndex === index : /\d/.test(letter);
    })
        .join('');
    if (viewValue.length === 0) {
        return getEmptyState({ viewValue, sign, finished, event });
    }
    const [intPart = '0', floatPart = ''] = viewValue
        .split(decimalSeparator)
        .map((numberPart) => numberPart || undefined);
    const correct = finished || (hasDot ? !!floatPart : true);
    viewValue = `${sign}${intPart}${hasDot && precision !== 0 && (!finished || correct) ? decimalSeparator : ''}${floatPart.slice(0, precision)}`;
    if (correct) {
        const floatValue = cast(viewValue.replace(decimalSeparator, '.'));
        // do not force clamping while user types
        const value = finished ? clamp(floatValue, min, max) : floatValue;
        const stringValue = String(value).replace('.', decimalSeparator);
        return {
            viewValue: thousandsSeparator
                ? (0, mask_1.default)(stringValue, (0, generateMask_1.default)(stringValue, {
                    thousandsSeparator,
                    decimalSeparator,
                    precision,
                })).maskedValue
                : stringValue,
            correct,
            value,
            event,
        };
    }
    return { viewValue, correct, value: null, event };
};
exports.default = getInputNumberFormatState;
